import appHome from "../../views/appHome.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("home", {
    parent: "app",
    url: "",
    views: {
      view: {
        template: appHome,
      },
    },
    reloadOnSearch: false,
    data: { title: "Home" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/home/home.urls.js